import styled from 'styled-components';

const TabSystemStatus = () => {
  const iFrameStyle = {
    height: '44px',
    width: '16rem',
  };

  return (
    <Container
      aria-label="iframe"
      src={'https://status.podium.com/embed-status/dark-sm'}
      frameBorder="0"
      scrolling="no"
      style={iFrameStyle}
    />
  );
};

const Container = styled.iframe`
  display: flex;
  border: none;
`;

export default TabSystemStatus;
